import DiscountIcon from "../images/icons/icon2.png";
import discountConnect from "./discountImages/discountConnect.png";
import discountSetupPermission from "./discountImages/discountSetupPermission.png";
import discountSetupContact from "./discountImages/discountSetupContact.png";
import discountConfirm from "./discountImages/discountConfirm.png";
import discountPrint from "./discountImages/discountPrint.png";
import logotype_finalStep from "./finalStepImages/logotype_finalStep.png";

import iconUpload from "../images/uploadArrow.png";

const discountBank = {
  id: "3",
  logo: DiscountIcon,
  name: "Discount Bank",
  steps: [
    {
      he: {
        title: `
                    <h2>
                          התחברות לחשבון הבנק
                      <br /> 
                    </h2>
                `,
        content: `
                    <p>
                     הכניסו את הפרטים
                      <br /> (פרטי ההתחברות אינם גלויים לנו)
                    </p>
                    `,
        stepScreen: discountConnect,
      },
    },
    {
      he: {
        title: `
                    <h2>
                      פנה/י לאישור הקמת הרשאה
                    </h2>
                    `,
        content: `
                            <p>
                              לחץ/י על ״עו״ש״
                              <br /> ולאחר מכן ״בקשה להקמת הרשאה חדשה לחיוב חשבון״ֿ
                              <br/>
                              <br/>  הכנס/י קוד מוסד 27662  
                              <br/> שים לב, שם המוסד הוא פיטופי שהוא שם החברה 
                              <br/>
                              <br/>  בחר ״כל סכום״ כתקרה לסכום
                              <br/> בחירת סכום כלשהו לא מומלצת מכיוון שקיימים לפעמים חיובים חד פעמיים 
                            </p>
                    `,
        stepScreen: discountSetupPermission,
      },
    },
    {
      he: {
        title: `
                    <h2>
                      מלא/י פרטי הרשאה
                    </h2>
                    `,
        content: `
                    <p>
                    
                      <br />
                      <br/> תחת ״אסמכתא״, כדי שנוכל לזהות אתכם
                      <br/> אנא מלא/י את מספר הטלפון שאיתו נרשמתם לבלינק/פיטופי 
                    </p>
                    `,
        stepScreen: discountSetupContact,
      },
    },
    {
      he: {
        title: `
                    <h2>
                      אישור להקמת הרשאה
                    </h2>
                    `,
        content: `
                    <p>
                        עבור/עברי על הפרטים 
                        <br/>
                        ואשר את הקמת ההרשאה
                    </p>
                    `,
        stepScreen: discountConfirm,
      },
    },
    {
      he: {
        title: `
                    <h2>
                      שלח/י אלינו את האישור
                    </h2>
                    `,
        content: `
                    <p>
                      לחיצה על הדפסה וייצוא ושמירה כקובץ fdp.
                      <br/>
                        לאחר מכן, העלה את הקובץ לעמוד ע״י לחיצה על אייקון החץ
                    </p>
                    `,
        button: {
          btnIcon: iconUpload,
          downloadTitle: `
                      <h3>העלאת קובץ אישור הקמת הרשאה</h3>
                      `,
        },
        stepScreen: discountPrint,
        hideNextButton: true
      },
    },
    {
      he: {
        title: `
                    <h2>
                      כל הכבוד!
                    </h2>
                    `,
        content: `
                    <p>
                      קיבלנו את הקובץ ונקים עבורך את ההרשאה תוך שני ימי עסקים 
                    </p>
                    `,
        finalStep: {
              logotype: logotype_finalStep,
              title_logotype: `
                      <h4>כל הכבוד!</h4>
                       `,
          },

      },
    },
  ],
};

export default discountBank;
